import React from "react";
import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import Icon from "../../components/Elements/Icon/Icon";
import Images from "../../constant/images";
import "../Home/Home.css";
import "../Overlapping/AboutSection.css";
import "../AboutUs/AboutUs.css";
import { OverlappingDesign } from "../Overlapping/OverlappingDesign";
import Card from "../../components/Elements/Card/Card";
import ButtonComponent from "../../components/Elements/Button/Button";
import "../Employer/Employer.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import LogoCarousel from "../carogel/carogel";
import { colors } from "@mui/joy";
import TestimonialCarousel from "../../components/TestimonialCarousel/users";

const Home = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(min-width: 320px) and (max-width: 900px)");

  const services = [
    {
      id: "01",
      title: "HR Consulting",
      icon: Images.one,
      marginleft: true,

      description:
        "We provide expert guidance and support to organizations seeking to optimize their human resources functions, improve performance, and achieve strategic objectives. From HR strategy alignment and talent management to organizational design, performance management, and compensation and benefits, our experienced HR consultants deliver tailored solutions that drive real results.",
    },
    {
      id: "02",
      icon: Images.three,
      marginleft: false,

      title: "Candidate Assessment & Evaluation",
      description:
        "We offer a comprehensive and objective evaluation of candidates to ensure the best fit for your organization. Our expert assessors utilize a range of tools and techniques, including behavioral - based interviews, skills assessments, and psychological evaluations, to accurately measure a candidate's skills, knowledge, and cultural alignment.",
    },
    {
      id: "03",
      icon: Images.three,
      marginleft: false,

      title: "Volume Recruitment Solutions",
      description:
        "Designed to support organizations with high-volume hiring needs, Al Maaly is providing a streamlined and efficient recruitment process that saves time, reduces costs, and ensures quality candidate acquisition. Our team of expert recruiters utilizes advanced recruitment technologies, social media, and innovative sourcing strategies to attract, engage, and assess large volumes of candidates, enabling clients to quickly fill multiple vacancies with top talent. ",
    },
    {
      id: "04",
      title: "Recruitment Process Outsourcing",
      marginleft: false,

      description:
        "We provide a comprehensive and customized solution for managing your organization's recruitment function. By outsourcing your recruitment process to us, you can tap into our expertise, technology, and resources to attract, select, and hire top talent. Our RPO service includes strategic workforce planning, employer branding, candidate sourcing, screening, and onboarding, allowing you to focus on your core business while we handle the recruitment process.",
    },
    {
      id: "05",
      title: "Executive Search Services",
      marginleft: false,

      description:
      "Offering a bespoke and confidential solution for identifying, assessing, and recruiting exceptional leaders and senior executives. Our experienced search consultants utilize a tailored approach, leveraging their extensive networks, industry expertise, and cutting-edge research techniques to pinpoint top talent that meets your organization's unique needs."
    },
    {
      id: "06",
      title: "IT Services",
      marginleft: false,

      description:
        "We emphasize on a change driven by technology and innovation. Our IT Services provide end-to-end solutions, from infrastructure management and cloud services to cybersecurity and data analytics. Our experts deliver tailored support, ensuring seamless operations, enhanced efficiency, and innovative solutions to drive business growth.",
    },
  ];
  const cards = [
    {
      icon: Images.vision, // Replace with your icon path
      title: "Our Vision",
      content: t("home.corporateGoal"), // Ensure 't' is properly imported and works as expected
    },
    {
      icon: Images.mission, // Replace with your icon path
      title: "Our Mission",
      content: t("home.redefineRecruitment"), // Ensure 't' is properly imported and works as expected
    },
    {
      icon: Images.global, // Replace with your icon path
      title: "Global Reach",
      content: t("home.strategy"), // Ensure 't' is properly imported and works as expected
    },
  ];

  // Reusable Custom Card Component
  const CustomCard = ({
    title,
    subtitle,
    hasIcon,
    Icon,
    whiteboxIcon,
    withBackground,
  }: any) => (
    <>
      <Box
        position="relative"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        {withBackground && (
          <Card
            style={{
              position: "absolute",
              width: "324px",
              height: "330px",
              backgroundColor: "#6B187A",
              transform: "rotate(-14deg)",
              borderRadius: "16px",
              zIndex: 1,
            }}
          />
        )}
        <Card
          style={{
            position: "relative",
            zIndex: 2,
            width: "324px",
            height: "330px",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "white",
            alignItems: "center",
            gap: "30px",
            boxShadow: "0px 0px 10px 0px #00000033",
            textAlign: "center",
            fontWeight: "bold",
            marginBottom: "10px",
            borderRadius: "15px",
          }}
        >
          {hasIcon && (
            <Box
              sx={{
                width: 80,
                height: 80,
                backgroundColor: "#6B187A",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "15px",
                color: "white",
                marginBottom: 2,
                marginTop: "50px",
              }}
            >
              <img src={Icon} alt="icon" width={40} height={40} />
            </Box>
          )}
          {whiteboxIcon && (
            <Box
              sx={{
                width: 80,
                height: 80,
                backgroundColor: "#red",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "15px",
                color: "white",
                marginBottom: 2,
                marginTop: "50px",
                boxShadow: "0px 0px 15px 0px #0000001A",
              }}
            >
              <img src={Icon} alt="icon" width={40} height={40} />
            </Box>
          )}
          {title && (
            <Box>
              <Typography
                variant="h6"
                align="center"
                className="aboutus-card-heading"
              >
                {title}
              </Typography>
              {subtitle && (
                <Typography
                  variant="body1"
                  align="center"
                  className="aboutus-card-heading"
                >
                  {subtitle}
                </Typography>
              )}
            </Box>
          )}
        </Card>
      </Box>
    </>
  );

  return (
    <>
      <Box>
        <Box padding={"30px"}>
          <Box className="imgconainer">
            <Box className="imagecontainer2">
              <Typography className="centered">The simplest method</Typography>
              <Typography className="centered">to land your new job</Typography>
              <Typography className="centered2">
                Every month, over 3 million job seekers visit the website,{" "}
              </Typography>
              <Typography className="centered2">
                {" "}
                submitting more than 140,000 applications daily.{" "}
              </Typography>
              <Box display={"flex"} gap={"10px"}>
                <Link to="/employer" style={{ textDecoration: "none" }}>
                  <ButtonComponent
                    type={"button"}
                    className={"HireButton-home"}
                    style={{
                      // marginRight: "25px",
                    }}
                  >
                    {t("employer.hireTalentButton")}
                  </ButtonComponent>
                </Link>
                <Link to="/opening" style={{ textDecoration: "none" }}>
                  <ButtonComponent
                    type={"button"}
                    className={"HireButton-home"}
                  >
                    {t("home.FindJobbtn")}
                  </ButtonComponent>
                </Link>
              </Box>
            </Box>
          </Box>

          {/* HR Consulting Section */}
          <Box margin={"40px 10px"}>
            <Typography variant="h5" className="heading">
              {t("home.hrConsulting")}
            </Typography>
            <Typography variant="body1" className="paragraph" mt={2}>
              {t("home.description")}
            </Typography>
          </Box>

          {/* Text Card Section */}
          <Box>
            <Box className="text-cadr-containt">
              <Box sx={{ padding: { xs: "20px 20px ", md: "60px" } }}>
                <Typography variant="body1" className="paragraph">
                  {t("home.recruitmentDescription")}
                </Typography>
              </Box>
            </Box>

            {/* mobile  */}

            <Box className="responsive-container">
              <Box
                width={{ xs: "90%", md: "100%" }}
                margin={{ xs: "auto" }}
                textAlign={"center"}
                zIndex={1}
              >
                <Icon
                  src={Images.textcardiconsmobile}
                  alt={""}
                  style={{ width: "100%" }}
                />
              </Box>
              <Box className="responsive-container-card" zIndex={1}>
                {cards.map((card, index) => (
                  <Card className="text-card" title="">
                    <Box key={index} display={"flex"} gap={"20px"} mb={2}>
                      <Box className="info-card">
                        <img
                          src={card.icon}
                          alt={`${card.title} Icon`}
                          className="card-icon"
                        />
                      </Box>
                      <Typography variant="h6" className="card-title">
                        {card.title}
                      </Typography>
                    </Box>
                    <Typography variant="body2" className="card-content">
                      {card.content}
                    </Typography>
                  </Card>
                ))}
              </Box>
            </Box>
            {/* destop */}
            <Box className="responsive-container-destop">
              <Box display={"grid"} gap={"50px"} width={"60%"} zIndex={1}>
                {cards.map((card, index) => (
                  <Card className="text-card" title="">
                    <Box key={index} display={"flex"} gap={"20px"} mb={2}>
                      <Box className="info-card">
                        <img
                          src={card.icon}
                          alt={`${card.title} Icon`}
                          className="card-icon"
                        />
                      </Box>
                      <Typography variant="h6" className="card-title">
                        {card.title}
                      </Typography>
                    </Box>
                    <Typography variant="body2" className="card-content">
                      {card.content}
                    </Typography>
                  </Card>
                ))}
              </Box>
              <Box width={"40%"} textAlign={"center"} zIndex={1}>
                <Icon src={Images.textcardicons} alt={""}  />
              </Box>
            </Box>
          </Box>

          {/* Dynamic Card Grid Section */}
        </Box>
        <Box className="responsive-hire-card">
          {/* Box 1 */}
          <Box width={isMobile ? "100%" : "50%"}>
            <Icon
              src={Images.homecard}
              style={{ width: isMobile ? "100%" : "100%" }}
              alt=""
            />
          </Box>
          {/* Box 2 */}
          <Box
            bgcolor="#E4DEEB"
            padding={isMobile ? "20px" : "40px"}
            textAlign="left"
            justifyContent="center"
            width={isMobile ? "auto" : "50%"}
          >
            <Typography className="home-left-employe-box">
              {t("home.carddescription")}
            </Typography>
            <Box>
              <Link to="/employer" style={{ textDecoration: "none" }}>
                <ButtonComponent
                  type={"button"}
                  className={"talentButton"}
                  style={{ background: "#741374", color: "white" }}
                >
                  {" "}
                  Hire The Best Talent
                  {/* {t("employer.hireTalentButton")} */}
                </ButtonComponent>
              </Link>
            </Box>
          </Box>
        </Box>
        <Box
          mt={8}
          justifyContent="center"
          alignItems="center"
          display={"flex"}
          flexDirection={"column"}
        >
          {" "}
          <Typography className="heading">{t("home.servicesTitle")}</Typography>
          <Typography className="home-card-title">
            {t("home.Recruitment")}
          </Typography>
          <Box mt={{xs:1,md:3}} display="flex" flexDirection="column" alignItems="center" width={{xs:"85%"}}>
            <Box mt={{xs:0.2,md:4}} width={{xs:"95%",md:"100%"}}>
              <Grid
                container
                spacing={3}
                justifyContent="center"
                padding={{xs:"0px ",md:"10px 70px "}}
              >
                {services.map((service, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <Box
                      display="flex"
                      gap={{ xs: "10px", md: "20px" }}
                      alignItems="flex-start"
                      // marginLeft={service.marginleft ? "16px" : ""}

                      sx={{
                        marginLeft: service.marginleft
                          ? { xs: "6px", md: "16px" } // xs par 8px, md par 16px
                          : "",
                      }}
                    >
                      <Typography className="numaric-value">
                        {service.id}
                      </Typography>
                      {/* <Icon src={service.icon} alt={""}></Icon> */}
                      <Card className="last-hero-card">
                        <Typography
                          className="home-card-heading"
                          lineHeight="none"
                          mb={1}
                          sx={{ textAlign: "left!important" }}
                        >
                          {service.title}
                        </Typography>
                        <Typography
                          className="home-card2-heading"
                          sx={{
                            textAlign: "left!important",
                            // fontSize: { xs: "12px !important", md: "18px !important" },
                            // lineHeight:{xs:"18px !important",md:""}
                          }}
                        >
                          {service.description}
                        </Typography>
                      </Card>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
        </Box>
        {/* Overlapping Design Section */}
        <Box mt={7}>
          <OverlappingDesign />
        </Box>
        <Box>
          <LogoCarousel></LogoCarousel>
        </Box>
        <Box
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          bgcolor={"#741374"}
          padding={"50px"}
          gap={"20px"}
        >
          <Typography className="bootom-heading" color="white">
            Let us help you find the best talent for your organization
          </Typography>
          {/* <Box display={"flex"} justifyContent={"center"}> */}
          <Link to="/employer" style={{ textDecoration: "none" }}>
            <ButtonComponent
              type={"button"}
              className={"talentButton"}
              style={{ color: "#741374", background: "white" }}
            >
              {" "}
              Hire a Talent
              {/* {t("employer.hireTalentButton")} */}
            </ButtonComponent>
          </Link>
          {/* </Box> */}
        </Box>
        {/* <TestimonialCarousel></TestimonialCarousel> */}
      </Box>
    </>
  );
};

export default Home;
